// Package imports:
import React from 'react';
// Component imports:
import HeadSection from '../../ui-elements/HeadSection/HeadSection';
import CompanySearchBar from './Search/Search';

const CompanySearch: React.FC = () => {
    return (
        <div className='main KCL_thjodskra-search'>
            <div className='main__inner-fluid'>
                <div className="shell">
                    <HeadSection 
                        title='Fyrirtækjaleit'
                        description={ <p>Hér getur þú flett upp nöfnum eða kennitölum.</p> }
                    />
                    <div style={{ 'marginBottom' : '500px'}}>
                       <CompanySearchBar />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CompanySearch;
